import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import validator from './plugins/validator'
import Notifications from 'vue-notification'
import service from './plugins/service'

Vue.config.productionTip = false
const plugin = {
    install (Vue) {
        Vue.prototype.$validator = validator
        Vue.prototype.$service = service
    }
}
Vue.use(plugin)
Vue.use(Notifications)

new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
}).$mount('#app')
